import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {DomainRecordEditComponent} from '../../components/DomainDataEdit/DomainRecordEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-domainrecord-grid',
  templateUrl: './DomainRecordGrid.component.html'
})
export class DomainRecordGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(DomainRecordEditComponent) recordEditComponent: DomainRecordEditComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    userInfo: ent.UserInfo;
    filter: filters.DomainRecordFilter;
    records: ent.DomainRecord[];
    selectedRecords: ent.DomainRecord[] = [];
    editedRecord: ent.DomainRecord;
    tableName: string;
    tableAttributes: ent.TableAttribute[];
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
        
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.DomainRecord();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            
        ];

        if (this.showAttribute('Code')){ this.cols.push({ field: 'Code', header: 'Code' });}
        if (this.showAttribute('Name')){ this.cols.push({ field: 'Name', header: 'Name' });}
        if (this.showAttribute('IEI_Eligible')){ this.cols.push({ field: 'IEI_Eligible', header: 'IEI Eligible' });}
        if (this.showAttribute('EnhancedPaymentOptions')){ this.cols.push({ field: 'EnhancedPaymentOptions', header: 'Enhanced Payment Options' });}
        if (this.showAttribute('AppliesToSoldTo')){ this.cols.push({ field: 'AppliesToSoldTo', header: 'Applies To Sold To' });}
        if (this.showAttribute('MinimumOrderQuantityFeeCode')){ this.cols.push({ field: 'MinimumOrderQuantityFeeCode', header: 'Minimum Order Quantity Fee Code' });}
        if (this.showAttribute('AuthorizedMaterialList')){ this.cols.push({ field: 'AuthorizedMaterialList', header: 'Authorized Material List' });}
        if (this.showAttribute('DrPepperAuthorizedMaterialList')){ this.cols.push({ field: 'DrPepperAuthorizedMaterialList', header: 'Dr Pepper Authorized Material List' });}
        if (this.showAttribute('MerchLevelCode')){ this.cols.push({ field: 'MerchLevelCode', header: 'Merch Level Code' });}
        if (this.showAttribute('OffDayDeliveryFee')){ this.cols.push({ field: 'OffDayDeliveryFee', header: 'Off-Day Delivery Fee' });}
        if (this.showAttribute('SalesOfficeNumber')){ this.cols.push({ field: 'SalesOfficeNumber', header: 'Sales Office Number' });}
        if (this.showAttribute('ClerkCode')){ this.cols.push({ field: 'ClerkCode', header: 'Clerk Code' });}
        if (this.showAttribute('ToleranceGroup')){ this.cols.push({ field: 'ToleranceGroup', header: 'Tolerance Group' });}
        if (this.showAttribute('FountainAvailable')){ this.cols.push({ field: 'FountainAvailable', header: 'Fountain Available' });}
        if (this.showAttribute('DistributionChannel')){ this.cols.push({ field: 'DistributionChannel', header: 'Distribution Channel' });}
        if (this.showAttribute('RequestReasonIDs')){ this.cols.push({ field: 'RequestReasonIDs', header: 'Request Reason IDs' });}
        if (this.showAttribute('RequiredAttachmentTypeIDs')){ this.cols.push({ field: 'RequiredAttachmentTypeIDs', header: 'Required Attachment Type IDs' });}
        if (this.showAttribute('IEI_Eligibility')){ this.cols.push({ field: 'IEI_Eligibility', header: 'IEI Eligibility' });}
        if (this.showAttribute('EnhancedPaymentOptionsText')){ this.cols.push({ field: 'EnhancedPaymentOptionsText', header: 'Enhanced Payment Options' });}
        if (this.showAttribute('PaymentEligibilityType')){ this.cols.push({ field: 'PaymentEligibilityType', header: 'Payment Eligibility' });}
        if (this.showAttribute('CRTNumber')){ this.cols.push({ field: 'CRTNumber', header: 'CRT Number' });}
        if (this.showAttribute('PrimaryGroup')){ this.cols.push({ field: 'PrimaryGroup', header: 'Primary Group' });}
        if (this.showAttribute('MyCokePermissions')){ this.cols.push({ field: 'MyCokePermissions', header: 'MyCoke Permissions' });}
        if (this.showAttribute('Inactive')){ this.cols.push({ field: 'Inactive', header: 'Inactive' });}

    }

    onSearchClick(event: any){

        this.blockComponent.blocked = true;
        var taFilter: filters.TableAttributeFilter = {TableName: this.tableName};
        this.domainDataService.getTableAttributes(taFilter).subscribe( y=>{
            
            this.tableAttributes = y;
            this.recordEditComponent.tableAttributes = y;
            this.loadColumns();

            this.filter = {TableName: this.tableName};

            this.domainDataService.getDomainRecords(this.filter).subscribe(x=>{
                this.records = x;
                this.blockComponent.blocked = false;
            });

        });
    }

    showAttribute(attributeName: string): boolean {
        if (!this.tableAttributes) {
            return false;
        }
        var tableAttribute = this.tableAttributes.filter(x=>x.Attribute.Name == attributeName)[0];
        return tableAttribute !== undefined;
    }

    onAddClick(event: any){
        this.editedRecord = new ent.DomainRecord();
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.DomainRecord){
        this.editedRecord = record;

        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveDomainRecordsRequest = {TableName: this.tableName,Records: [this.editedRecord], SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveDomainRecords(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
   
}